module.exports = __webpack_public_path__ + "img/step4-01.cc48ccf4.jpg";